import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { Spinner } from '@offerzen/pinata'
import styles, { buttonSize, buttonStyle, spinnerVariant } from './styles'

const ButtonLoader = ({ theme, size, style, className, label }) => (
  <button className={cx(styles.button, className, buttonSize(size), buttonStyle(style, theme))} type="button" role="status" tabIndex="-1">
    <Spinner theme={theme} variant={spinnerVariant(style)} className={styles.spinner} />
    {label}
  </button>
)

ButtonLoader.propTypes = {
  label: PropTypes.string,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  size: PropTypes.oneOf(['', 'default', 'small', 'medium', 'large']),
  style: PropTypes.oneOf(['', 'default', 'outlined', 'dashed']),
  className: PropTypes.string,
}

ButtonLoader.defaultProps = {
  label: 'Loading',
  theme: 'primary',
  size: 'default',
  style: 'default',
}

export default ButtonLoader
